var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"wrap gray"},[_c('div',{staticClass:"container-wrap observer-selector"},[_c('div',{staticClass:"title"},[_vm._v("많은 사람들이 디버를 선택하는 이유")]),_c('div',{staticClass:"box-wrap"},_vm._l((_vm.infoList),function(list){return _c('div',[_c('Box',{ref:"boxes",refInFor:true,attrs:{"list":list}})],1)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }